(function () {
  let productBgSlider;
  let productImageSlider;

  let productSliders = destroy => {
    if (destroy) {
      productBgSlider.destroy();
      productImageSlider.destroy();
    }

    let productBgSliderAutoplay = (document.querySelectorAll('.product-cst-bgs .swiper-slide').length > 1) ? true : false;
    let productImageSliderAutoplay = (document.querySelectorAll('.product-cst-imgs .swiper-slide').length > 1) ? true : false;
    if(productBgSliderAutoplay){
      productBgSlider = new Swiper('.product-cst-bgs', {
      speed: 500,
      effect: 'fade',
      loop: productBgSliderAutoplay,
      autoplay: productBgSliderAutoplay,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
      productBgSlider.controller.control = productImageSlider;
    }
    if(productBgSliderAutoplay){
          productImageSlider = new Swiper('.product-cst-imgs', {
      speed: 500,
      effect: 'fade',
      loop: productImageSliderAutoplay,
      autoplay: productImageSliderAutoplay,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
      productImageSlider.controller.control = productBgSlider;
    }

    
  }

  productSliders();

  document.querySelectorAll('.variant-input input[name="Color"]').forEach( colorElement => {
    colorElement.addEventListener( 'change', () => {
      let colorValue = colorElement.value.toLowerCase().replace(/ /g,'-');
      // console.log(colorElement.value.toLowerCase().replace(/ /g,'-'));
      console.log(`this is Color Element ${colorElement.value}`);

      if (document.querySelectorAll('.variant-has-color').length) {
        console.log(document.querySelectorAll('.variant-has-color').length);
        document.querySelectorAll('.product-variant-img.swiper-slide').forEach( element => {
          element.classList.remove('swiper-slide');
        });

        document.querySelectorAll(`.product-variant-img.color-${colorValue}`).forEach( element => {
          element.classList.add('swiper-slide');
        });

        productSliders(destroy = true);
      }
      const mobileVariants = document.querySelector(".mobile-buy-buttons__item.item-variant");
      if(mobileVariants){
        const currentValue = mobileVariants.querySelector(".color-swatch__icon.show")
        const newValue = mobileVariants.querySelector(`.color-swatch__icon[data-option="${colorElement.value}"]`);     
        currentValue.classList.remove("show");
        currentValue.classList.add("hide");
        newValue.classList.remove("hide");
        newValue.classList.add("show");
      }
    });
  });

  
  // let ProductBackgroundSlider;
  // let ProductImageSlider;

  //   let productSlider = (destroy) => {
  //     if (destroy) {
  //       ProductBackgroundSlider.destroy();
  //       ProductImageSlider.destroy();
  //     }
  //     let productBackgroundAutoplay = (document.querySelectorAll('.product-cst-bgs .swiper-slide').length > 1) ? true : false;
  //     let productImageAutoplay = (document.querySelectorAll('.product-cst-imgs .swiper-slide').length > 1) ? true : false;
  //     ProductBackgroundSlider = new Swiper(".product-cst-bgs", {
  //       speed: 500,
  //       effect: 'fade',
  //       loop: productBackgroundAutoplay,
  //       autoplay: productBackgroundAutoplay,
  //       autoplay: {
  //         delay: 3000,
  //       },
  //       pagination: {
  //         el: '.swiper-pagination',
  //         clickable: true
  //       }
  //     });
  //     ProductImageSlider = new Swiper('.product-cst-imgs', {
  //       speed: 500,
  //       effect: 'fade',
  //       loop: productImageAutoplay,
  //       autoplay: productImageAutoplay,
  //       pagination: {
  //         el: '.swiper-pagination',
  //         clickable: true
  //       }
  //     });
  //     ProductBackgroundSlider.controller.control = ProductImageSlider;
  //     ProductImageSlider.controller.control = ProductBackgroundSlider;
  //   }

  //   productSlider();

  //   document.querySelectorAll('.variant-input input[name="Color"]').forEach( (element) => {
  //     element.addEventListener('change', () => {
  //       let colorOfValue = element.value.toLowerCase().replace(/ /g,'-');
  //       console.log(`this is Color Element ${element.value}`);

  //       if (document.querySelectorAll('.variant-has-color').length) {
  //         document.querySelectorAll('.product-variant-img.swiper-slide').forEach( ele => {
  //           ele.classList.remove('swiper-slide');
  //         });
  
  //         document.querySelectorAll(`.product-variant-img.color-${colorOfValue}`).forEach( ele => {
  //           ele.classList.add('swiper-slide');
  //         });
  
  //         productSlider(destroy = true);
  //       }
  //     });
  //   })
  
  
  
  

  // Product Info Section Slider
  document.querySelectorAll('.info-tab-section').forEach( tabSection => {
    const tabSliderElement = tabSection.querySelector('.info-tab-slider');

    if (tabSliderElement) {
      const autoHeight = (tabSliderElement.dataset.autoHeight == 'true') ? true : false;
      
      const tabSlider = new Swiper( tabSliderElement , {
        speed: 500,
        autoHeight: autoHeight,
        effect: 'fade',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
      });
    
      tabSlider.on('slideChange', function (e) {
        let thiSection = tabSlider.$el[0].closest('.info-tab-section');
        let goToIndex = tabSlider.realIndex + 1;
        
        thiSection.querySelector(`.info-tab-item[data-index="${goToIndex}"]`).click();
      });
    }
  });
  
  document.querySelectorAll('.info-tab-item').forEach( (element) => {
    element.addEventListener('click', () => {
      let section = element.closest('.info-tab-section');
      let slider = section.querySelector('.info-tab-slider').swiper;
      let index = element.dataset.index;

      let scrollLeft = section.querySelector('.info-tab-list .row').scrollLeft;
      let offsetLeft = element.offsetLeft;
      let scrollValue = (offsetLeft - 15);

      let colorValue = element.dataset.arrowsColor;

      if (!element.classList.contains('active')) {
        section.style.setProperty('--arrows-color', colorValue);
        section.querySelector('.info-tab-item.active').classList.remove('active');
        section.querySelector('.info-tab-list .row').scrollLeft = scrollValue;
        
        element.classList.add('active');

        slider.slideTo(index, 500);
      }
    });
  });

  document.querySelectorAll('.info-tab-section .arrow-btn').forEach( (element) => {
    element.addEventListener('click', () => {
      let section = element.closest('.info-tab-section');
      let slider = section.querySelector('.info-tab-slider').swiper;
      
      let length = section.querySelectorAll('.info-tab-item').length;
      let activeIndex = parseInt(section.querySelector('.info-tab-item.active').dataset.index);
      let goToIndex = 0;

      if (element.classList.contains('next')) {
        goToIndex = (activeIndex == length) ? 1 : (activeIndex + 1);
        slider.slideNext(500);
      } else {
        goToIndex = (activeIndex == 1) ? length : (activeIndex - 1);
        slider.slidePrev(500);
      }

      section.querySelector(`.info-tab-item[data-index="${goToIndex}"]`).click();
    });
  });
  if(document.querySelector('.variant-slider')){
    var productVariantSlider = new Flickity( '.variant-slider', {
    cellAlign: 'left',
    wrapAround: true,
    prevNextButtons: false,
    autoPlay: true
  });
  }
  
  
  $(productVariantSlider).on( 'change', function( index ) {
    let thiSection = productVariantSlider.$element[0].closest('.product-featured-variants');
    $(thiSection).find(`.color-swatch-item[data-index="${index + 1}"]`).addClass('selected').siblings('.color-swatch-item').removeClass('selected');
  });
  
  $(document).on('click', '.color-swatch-item', function () {
    let thiSection = $(this).closest('.product-featured-variants');
    let index = $(this).data('index') - 1;
    
    productVariantSlider.select(index);
    $(this).addClass('selected').siblings('.color-swatch-item').removeClass('selected');
  });
  
  $(document).on('click', '.product-featured-variants .arrow-btn', function () {
    if ($(this).is('.next')) {
      productVariantSlider.next();
    } else {
      productVariantSlider.previous();
    }
  });
  
  // $(document).on('click', '.product-accordion-title', function () {
  //   $(this).toggleClass('active');
  //   $(this).next('.product-accordion-content').slideToggle(300);
  // });
  
  $(document).on('click', '.faq-title', function () {
    $(this).toggleClass('active');
    $(this).next('.faq-content').slideToggle(300);
  });
 if(document.querySelector('.gallery-slider')){
     const gallerySlider = new Flickity( '.gallery-slider', {
    cellAlign: 'left',
    wrapAround: true,
    prevNextButtons: false,
  });
 }


  $(document).on('click', '.gallery-slider-wrapper .arrow-btn', function () {
    if ($(this).is('.next')) {
      gallerySlider.next();
    } else {
      gallerySlider.previous();
    }
  });

  $(document).on('click', '.click-to-key-specification', function () {
    var targetOffset = $('.accordion-target-section').offset().top - 250;
    $('html, body').animate({
      scrollTop: targetOffset
    }, 200);
    return false;
  });
})();

